<template>
  <div>
    <!-- 数据加载组件 -->
  </div>
</template>

<script>
import { listMyStore, listMyEnteredShops, queryStaffPrivileges } from '@/api/frame/wuyeRegisterApi'
import { getShopId } from '@/api/shop/shopApi'
import { setCurrentShop } from '@/utils/vc'

export default {
  name: 'InitData',
  data() {
    return {
      initDataInfo: {}
    }
  },
  methods: {
    // 从 localStorage 读取数据的方法
    getStoredData(key) {
      try {
        const data = localStorage.getItem(key)
        return data ? JSON.parse(data) : null
      } catch (error) {
        console.error(`读取 localStorage 数据失败 (${key}):`, error)
        return null
      }
    },

    // 清除所有存储的数据
    clearStoredData() {
      try {
        localStorage.removeItem('userPrivileges')
        localStorage.removeItem('privilegesData')
        localStorage.removeItem('currentCommunity')
        localStorage.removeItem('communities')
        localStorage.removeItem('shopId')
        localStorage.removeItem('myStores')
        console.log('已清除所有存储的数据')
      } catch (error) {
        console.error('清除存储数据失败:', error)
      }
    },

    async loadShopInfo(params) {
      try {
        await this._validateHasStore(params)
      } catch (error) {
        console.error('加载商店信息失败:', error)
      }
    },

    async _validateHasStore(params) {
      try {
        const res = await listMyStore({ _uId: getShopId() })
        // 存储我的店铺数据到 localStorage
        localStorage.setItem('myStores', JSON.stringify(res.data || []))
        await this._loadStaffPrivileges(params)
      } catch (err) {
        if (err.response && err.response.status === 403) {
          this.$router.push("/#/pages/common/company")
        } else {
          this.$message.error(err.message)
        }
        throw err
      }
    },

    async _loadStaffPrivileges(params) {
      try {
        const res = await queryStaffPrivileges({ a: 'HC' })
        const privileges = res.datas.map(item => item.pId)
        // 存储权限数据到 localStorage
        localStorage.setItem('userPrivileges', JSON.stringify(privileges))
        localStorage.setItem('privilegesData', JSON.stringify(res.datas))
        await this._loadShopInfo(params)
      } catch (err) {
        console.error('请求失败:', err)
        throw err
      }
    },

    async _loadShopInfo(params) {
      try {
        const res = await listMyEnteredShops({
          _uId: getShopId(),
          page: 1,
          row: 3
        })

        const shops = res.data || []
        if (shops.length > 0) {
          // 存储商店数据到 localStorage
          setCurrentShop(shops[0])
          localStorage.setItem('shops', JSON.stringify(shops))
          localStorage.setItem('shopId', getShopId())
          if (params.url.indexOf('http') > -1) {
            window.location.href = params.url
            return
          }
          this.$router.push(params.url)
        } else {
          this.$message.warning(this.$t('wuyeRegister.noShopWarning'))
        }
      } catch (err) {
        console.error('请求失败:', err)
        this.$router.push(params.url)
        throw err
      }
    }
  }
}
</script>